import React, { useEffect, useState } from "react";
import {
  getGreBannerCacheEntry,
  preloadGreBannerImage,
} from "utils/greBannerImageLoader";
import { isValidMongoObjectId, normalizeMongoId } from "utils/utils";

/**
 * GRE form banner via authenticated blob API only.
 * Public CloudFront gre_banner_url returns 403 for private S3 objects.
 */
const GreBannerImage = ({
  propertyId,
  propertyTitle = "",
  className = "",
  withShell = false,
  fullWidth = false,
  imageClassName = "",
  imageStyle = {},
  hasBanner = null,
}) => {
  const normalizedPropertyId = normalizeMongoId(propertyId);
  const cached = getGreBannerCacheEntry(normalizedPropertyId);
  const [imageSrc, setImageSrc] = useState(
    cached?.status === "ready" ? cached.objectUrl : null,
  );
  const [loading, setLoading] = useState(
    Boolean(
      isValidMongoObjectId(normalizedPropertyId) &&
        hasBanner !== false &&
        cached?.status !== "ready" &&
        cached?.status !== "empty",
    ),
  );

  useEffect(() => {
    let cancelled = false;
    const id = normalizeMongoId(propertyId);

    if (!isValidMongoObjectId(id) || hasBanner === false) {
      setImageSrc(null);
      setLoading(false);
      return undefined;
    }

    const existing = getGreBannerCacheEntry(id);
    if (existing?.status === "ready" && existing.objectUrl) {
      setImageSrc(existing.objectUrl);
      setLoading(false);
      return undefined;
    }
    if (existing?.status === "empty") {
      setImageSrc(null);
      setLoading(false);
      return undefined;
    }

    setLoading(true);
    preloadGreBannerImage(id, { hasBanner }).then((entry) => {
      if (cancelled) {
        return;
      }
      setLoading(false);
      setImageSrc(entry?.status === "ready" ? entry.objectUrl : null);
    });

    return () => {
      cancelled = true;
    };
  }, [propertyId, hasBanner]);

  if (!loading && !imageSrc) {
    return null;
  }

  const image = imageSrc ? (
    <img
      src={imageSrc}
      alt={
        propertyTitle
          ? `${propertyTitle} property branding`
          : "Property branding"
      }
      className={imageClassName || className}
      style={imageStyle}
    />
  ) : (
    <div
      className={`${imageClassName || className} gre-banner-shell__placeholder`.trim()}
      aria-hidden="true"
    />
  );

  if (!withShell) {
    return image;
  }

  const columnClass = fullWidth ? "col-12" : "col-12 col-md-10 col-lg-8";

  return (
    <div
      className={`row justify-content-center mb-4 ${className}`.trim()}
    >
      <div className={columnClass}>
        <div
          className={`gre-banner-shell${loading && !imageSrc ? " gre-banner-shell--loading" : ""}`}
        >
          {image}
        </div>
      </div>
    </div>
  );
};

export default GreBannerImage;
